import React, { useEffect, useState } from "react";
import ToDo from "./ToDo";
import "./App.css";
import db from "./firebase";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

function App() {
  const [todos, setTodos] = useState([]);
  const [input, setInput] = useState("");

  useEffect(() => {
    db.collection("todos")
      .orderBy("timestamp", "desc")
      .onSnapshot((snapshot) => {
        setTodos(
          snapshot.docs.map((doc) => ({ id: doc.id, todo: doc.data().todo }))
        );
        // console.log(snapshot.docs.map(doc => doc.data().todo))
      });
  });

  const addTodos = (event) => {
    //auto refreshing will OFF ----
    event.preventDefault();

    //adding new todo to db
    db.collection("todos").add({
      todo: input,
      //for time independece by zone or for ordering it in (asce/desc)
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    });

    setInput("");
  };

  return (
    <div className="App">
      <h1>ToDo App🔥</h1>
      <form action="">
        <input
          className="input"
          label="Add To Do"
          variant="filled"
          type="text"
          value={input}
          onChange={(event) => setInput(event.target.value)}
        />
        <button
          disabled={!input}
          variant="contained"
          type="submit"
          onClick={addTodos}
        >
          Add To Do
        </button>
      </form>

      <ul>
        {todos.map((todo) => (
          <ToDo todo={todo} />
        ))}
      
      </ul>
    
    </div>
  );
}

export default App;
